/* eslint-disable */
import React from "react";
import { Button, Group, Modal, Text } from "@mantine/core";

import ModalHeader from "components/ModalHeader";
import { useImpersonateUser } from "api/superAdmin/userSuperAdminId";
import UpdateMeeting from "./updateForm";

interface User {
  id: string;
  userName: string;
}

type CreateProjectModalProps = {
  opened: boolean;
  onClose: () => void;
  currentMeetingId: string | any;
};

function UpdateMeetingModal({
  opened,
  onClose,
  currentMeetingId,
}: CreateProjectModalProps) {
  return (
    <Modal
      size="xl"
      opened={opened}
      onClose={onClose}
      overlayOpacity={0.5}
      shadow="xs"
      withCloseButton={false}
      transitionDuration={300}
      centered
    >
      <ModalHeader
        title="update Meeting"
        onClose={onClose}
        ariaLabel="Close Login Modal"
      />
      <UpdateMeeting onClose={onClose} currentMeetingId={currentMeetingId} />
    </Modal>
  );
}

export default UpdateMeetingModal;
